/**Dependencies */
import React from 'react'

/**Components */
import { Container, Row, Col } from 'react-bootstrap';

/**Images */
import iconHotels from '../images/icons/icon-hotels.png';
import iconTours from '../images/icons/icon-tours.png';
import iconCircuitos from '../images/icons/icon-circuitos.png';
import iconCursos from '../images/icons/icon-cursos.png';


export const SectionOurServices = () => {
    const items = [
        { image: iconHotels, text: "Hoteles" },
        { image: iconTours, text: "Tours" },
        { image: iconCircuitos, text: "Circuitos" },
        { image: iconCursos, text: "Cursos" },
      ];

  return (
    <div>
        <Container>          
            <div className="text-center mb-5">
              <h1 className='section-title outline'>Nuestros servicios</h1>
              <p className='section-subtitle'>Descubre todos los servicios que tenemos para ti</p>  
            </div>    
            <Row className="text-center pb-5">
              {items.map((item, index) => (
                <Col key={index} md={3} sm={6} xs={6} className="mb-4">
                  <img
                    src={item.image}
                    alt={`Imagen ${index + 1}`}
                    className="img-fluid mb-2"
                    style={{ maxHeight: "150px" }}
                  />
                  <p className='text-blue' style={{fontStyle:'italic', fontSize:'17px'}}>{item.text}</p>
                </Col>
              ))}
            </Row>                    
          </Container>
    </div>
  )
}
